
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { consumptionData } from '@/data/energy-analytics-data';

const ConsumptionBarChart = () => {
  return (
    <AnimatedCard 
      animation="fade-up" 
      delay={500}
      className="bg-white dark:bg-gray-800 border-none lg:col-span-2"
    >
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-semibold">Monthly Energy Consumption (kWh)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={consumptionData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip 
                formatter={(value) => [`${value} kWh`, 'Consumption']}
                contentStyle={{ 
                  borderRadius: '8px', 
                  border: 'none', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
                }}
              />
              <Bar dataKey="consumption" fill="#0A84FF" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </AnimatedCard>
  );
};

export default ConsumptionBarChart;
